import { cva } from 'class-variance-authority';

export type Size = 'large' | 'normal' | 'small' | 'byBreakpoint';

const flagSizeVariants = {
  large: 'px-1',
  normal: 'px-0.5',
  small: 'px-0.5',
  byBreakpoint: 'px-0.5 lg:px-1',
} satisfies Record<Size, string>;

const labelSizeVariants = {
  large: 'text-size-headline-3xl',
  normal: 'text-size-headline-2xl',
  small: 'text-size-headline-base',
  byBreakpoint: 'text-size-headline-2xl lg:text-size-headline-3xl',
} satisfies Record<Size, string>;

const iconSizeVariants = {
  large: 'h-4 w-4',
  normal: 'h-2 w-2',
  small: 'h-2 w-2',
  byBreakpoint: 'h-2 w-2 lg:h-4 lg:w-4',
} satisfies Record<Size, string>;

// NOTE: overflow-hidden is used as a workaround for the focus outline on keyboard navigation having a weird protrusion at the top
export const flag = cva(
  'border-color-text-dark inline-flex items-center overflow-hidden rounded-sm border',
  {
    variants: {
      size: flagSizeVariants,
    },
    defaultVariants: {
      size: 'normal',
    },
  },
);

export const label = cva('font-family-efficiency-label whitespace-nowrap', {
  variants: {
    size: labelSizeVariants,
  },
  defaultVariants: {
    size: 'normal',
  },
});

export const icon = cva('mr-0.5', {
  variants: {
    size: iconSizeVariants,
    type: {
      fuelEfficiency: 'icon-emp-fuel-efficiency',
      wetGrip: 'icon-emp-wet-grip',
      externalRollingNoise: 'icon-emp-external-rolling-noise',
    },
  },
  defaultVariants: {
    size: 'normal',
  },
});
